import {trackEvent} from '@jetbrains/teamcity-ui/dist/statistics'

import {openWhatsNew} from '../../../actions'
import {useAppDispatch} from '../../../hooks/react-redux'
import {useSetUserProperty} from '../../../hooks/useSetUserProperty'
import {useBooleanUserProperty} from '../../../hooks/useUserProperty'
import {UserProperties} from '../../../utils/userProperties'

function useWelcomePopup() {
  const showPopup = useBooleanUserProperty(UserProperties.SHOW_WELCOME_POPUP, true)
  const setUserProperty = useSetUserProperty()
  const dispatch = useAppDispatch()
  const onClose = () => {
    setUserProperty(UserProperties.SHOW_WELCOME_POPUP, 'false')
    trackEvent({name: 'close.click', groupId: 'welcomepopup.events.group'})
    dispatch(openWhatsNew())
  }
  const onCallToActionClick = () => onClose()

  return {
    showPopup,
    onClose,
    onCallToActionClick,
  }
}

export default useWelcomePopup
